import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=60f2eeae&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60f2eeae')) {
      api.createRecord('60f2eeae', component.options)
    } else {
      api.reload('60f2eeae', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=60f2eeae&", function () {
      api.rerender('60f2eeae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VFRBCmrj5CmZ/JS/comp/openstreetmap.vue"
export default component.exports